import React from 'react';
import { Grid, Typography, Container } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';

import Header from './header.jsx'
import InputData from './InputData.jsx'
import Box from '@material-ui/core/Box';
import Output1 from './Output1.jsx'

import { log } from 'mathjs';


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { alert: false };
    this.myRef = React.createRef();
  }

  handleChange = (state) => {
    let c1 = state.age >= 20 && state.age <= 100;;
    let c2 = state.ca125 >= log(2.7) && state.ca125 <= log(45200);
    let c5 = state.pln == 1 || state.pln == 0;
    let c6 = state.nac == 1 || state.nac == 0;
    let c7 = state.sbm1 == 1 || state.sbm1 == 0;
    let c8 = state.sbm2 == 1 || state.sbm2 == 0;

    let c9 = state.opt1 == 1 || state.opt1 == 0;
    let c10 = state.opt2 == 1 || state.opt2 == 0;


    let error_check = [c1, c2, c5, c6, c7, c8, c9, c10]
    if (c1 && c2 && c5 && c6 && c7 && c8 && c9 && c10) {
      this.setState({ ...state, alert: false, error_check, model: "M1" })
    }
    else {
      this.setState({ alert: true, error_check })
    }
  }

  alert = () => {
    if (this.state.alert === true) {
      return <Alert severity="error">Invalid Input</Alert>
    }
  }
  renderSwitch = (param, alert) => {
    console.log("submit is clicked")
    if (!alert) {
      console.log(param)

      switch (param) {
        case "M1":
          return <Output1 data={this.state}></Output1>
        default:
      }
    }

  }

  render() {
    return (
      <div className="App">
        <Grid container direction="column" spacing={3}>
          <Grid item><Header></Header></Grid>
          <Grid item container>
            <Grid item xs={1} />
            <Grid item xs={8} >
              <Typography>
                <Box fontWeight="fontWeightBold" fontSize={25}>
                  Patient Information
                    </Box>
              </Typography>
              <div className="alert">
                {this.alert()}
              </div>
              <div className="Input" style={{ width: 1200 }}>
                <InputData onSubmit={this.handleChange}></InputData>
              </div>
              <Typography>
                <Box fontWeight="fontWeightBold" fontSize={25}>
                  Predicted Result
                    </Box>
              </Typography>
              <div className="Output" style={{ width: 1200 }}>
                {this.renderSwitch(this.state.model, this.state.alert)}
              </div>

            </Grid>
          </Grid>
          <footer class="footer">
            <Typography align="center" >

              <Box fontSize={15} >
                <br />
                <br /> Version 1.1 by April 2, 2021.
                <br /> Created by BIBS Labratory, Seoul National University
                <br /> Developed and Maintained by Chanhee Lee, lch951022@gmail.com
              </Box>
            </Typography>

          </footer>
        </Grid>


      </div>

    );
  };
}

export default App;
